import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { ViewScopeService } from '../services/view-scope.service';
import { AuthStateService } from '../services/auth-state.service';

// Waits for the session-cookie check (AuthStateService.ensureInitialized()) before judging
// identity - see AuthStateService for why bootstrap ordering alone isn't sufficient.
// NB: today HomeRedirectGuard's canActivate on the parent '' route always evaluates first
// and already redirects unauthenticated users to /landing before this guard's
// canActivateChild ever runs, so the redirect below is presently unreachable - kept aligned
// to the same "not allowed → landing, not login" policy in case routing changes.
@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
	constructor(
		private router: Router,
		private viewScopeService: ViewScopeService,
		private authStateService: AuthStateService
	) { }

	canActivate(): Observable<boolean | UrlTree> {
		return this.authStateService.ensureInitialized().pipe(
			map(() => {
				const id = this.viewScopeService.getCurrentOpertaingUserId();

				// If id is valid and strictly greater than 0, allow access
				if (!isNaN(id) && id > 0) {
					return true;
				}

				// If id <= 0, missing, or NaN, not allowed in the system → landing
				return this.router.createUrlTree(['/landing']);
			})
		);
	}

	canActivateChild(): Observable<boolean | UrlTree> {
		return this.canActivate();
	}
}